<template>
  <transition name="template-notification">
    <v-snackbar
      v-model="show"
      class="white--text template-notification"
      color="var(--black-color)"
      right
      :timeout="1000"
      top>
      {{ options.add ? $t('Common.AddToTemplates', {name: options.name})
        : options.remove ? $t('Application.RemoveFromApps', {name: options.name})
          : $t('Common.RemoveFromTemplates', {name: options.name}) }}
    </v-snackbar>
  </transition>
</template>
<script>
export default {
  name: 'templateSnackbar',
  data () {
    return {
      show: false,
      options: {}
    }
  },
  mounted() {
    this.$root.$on('showTemplateNotification', this.onShowTemplateNotification)
  },
  beforeDestroy() {
    this.$root.$off('showTemplateNotification', this.onShowTemplateNotification)
  },
  methods: {
    onShowTemplateNotification(options) {
      this.show = true
      this.options = options
    },
    onCloseTemplateNotification() {
      this.show = false
      this.options = {}
    },
  },
}

</script>
<style lang="scss" scoped>

.template-notification-enter-active, .template-notification-leave-active {
  transition: opacity .3s ease;
}
.template-notification-enter, .template-notification-leave-active
 {
  opacity: 0;
 }
</style>
